module.exports = __webpack_public_path__ + "img/advantages-bg--767.efb8153.webp";